var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconReply = function SvgIconReply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.556 10h.01M11 10h.011m4.433 0h.012M21 10c0 4.97-4.478 9-10 9-1.635.006-3.25-.36-4.728-1.068L1 19l1.55-4.185C1.569 13.422 1 11.771 1 10c0-4.97 4.478-9 10-9s10 4.03 10 9"
  })));
};
export default SvgIconReply;